import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AdminDashboard from "@/pages/AdminDashboard";
import ContractorPortal from "@/pages/ContractorPortal";
import ContractorHome from "@/pages/ContractorHome";
import CityLandingPage from "@/pages/CityLandingPage";
import DemoWalkthrough from "@/pages/DemoWalkthrough";
import AboutPage from "@/pages/AboutPage";
import InstantEstimatePage from "@/pages/InstantEstimatePage";
import SEOPage from "@/pages/SEOPage";
import CheckAcAgePage from "@/pages/CheckAcAgePage";
import AcLifespanPage from "@/pages/AcLifespanPage";
import RepairVsReplacePage from "@/pages/RepairVsReplacePage";
import AcProblemPage from "@/pages/AcProblemPage";
import CommonAcProblemsPage from "@/pages/CommonAcProblemsPage";
import EstimateResultPage from "@/pages/EstimateResultPage";
import ServiceRequestPage from "@/pages/ServiceRequestPage";
import BrandProblemPage from "@/pages/BrandProblemPage";
import WhoMakesHvacPage from "@/pages/WhoMakesHvacPage";
import RefrigerantGuidePage from "@/pages/RefrigerantGuidePage";
import CompareContractorsPage from "@/pages/CompareContractorsPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import AcSizingPage from "@/pages/AcSizingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/instant-hvac-estimate-new-orleans" element={<InstantEstimatePage />} />
          <Route path="/hvac-pricing-new-orleans" element={<SEOPage />} />
          <Route path="/ac-replacement-cost-new-orleans" element={<SEOPage />} />
          <Route path="/hvac-estimate-metairie" element={<SEOPage />} />
          <Route path="/hvac-estimate-kenner" element={<SEOPage />} />
          <Route path="/check-ac-age" element={<CheckAcAgePage />} />
          <Route path="/ac-unit-lifespan-louisiana" element={<AcLifespanPage />} />
          <Route path="/repair-vs-replace-ac" element={<RepairVsReplacePage />} />
          <Route path="/ac-blowing-warm-air" element={<AcProblemPage />} />
          <Route path="/ac-freezing-up" element={<AcProblemPage />} />
          <Route path="/ac-running-but-not-cooling" element={<AcProblemPage />} />
          <Route path="/ac-leaking-water" element={<AcProblemPage />} />
          <Route path="/ac-not-turning-on" element={<AcProblemPage />} />
          <Route path="/ac-making-loud-noise" element={<AcProblemPage />} />
          <Route path="/common-ac-problems" element={<CommonAcProblemsPage />} />
          <Route path="/estimate-result/:id" element={<EstimateResultPage />} />
          <Route path="/schedule-ac-repair" element={<ServiceRequestPage />} />
          <Route path="/schedule-heating-service" element={<ServiceRequestPage />} />
          <Route path="/request-duct-cleaning" element={<ServiceRequestPage />} />
          <Route path="/maintenance-plans" element={<ServiceRequestPage />} />
          <Route path="/daikin-ac-problems" element={<BrandProblemPage />} />
          <Route path="/goodman-ac-problems" element={<BrandProblemPage />} />
          <Route path="/amana-ac-problems" element={<BrandProblemPage />} />
          <Route path="/trane-ac-problems" element={<BrandProblemPage />} />
          <Route path="/american-standard-ac-problems" element={<BrandProblemPage />} />
          <Route path="/oxbox-ac-problems" element={<BrandProblemPage />} />
          <Route path="/carrier-ac-problems" element={<BrandProblemPage />} />
          <Route path="/bryant-ac-problems" element={<BrandProblemPage />} />
          <Route path="/payne-ac-problems" element={<BrandProblemPage />} />
          <Route path="/rheem-ac-problems" element={<BrandProblemPage />} />
          <Route path="/ruud-ac-problems" element={<BrandProblemPage />} />
          <Route path="/york-ac-problems" element={<BrandProblemPage />} />
          <Route path="/who-makes-hvac-systems" element={<WhoMakesHvacPage />} />
          <Route path="/hvac-refrigerant-guide" element={<RefrigerantGuidePage />} />
          <Route path="/compare-hvac-contractors" element={<CompareContractorsPage />} />
          <Route path="/how-nola-hvac-connect-works" element={<HowItWorksPage />} />
          <Route path="/what-size-ac-unit-do-i-need" element={<AcSizingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/contractors" element={<ContractorHome />} />
          <Route path="/contractors/portal" element={<ContractorPortal />} />
          <Route path="/demo" element={<DemoWalkthrough />} />
          {/* City-specific landing pages for Google Ads */}
          <Route path="/hvac/:city" element={<CityLandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
